import { render, staticRenderFns } from "./BlockRequisitesItem.vue?vue&type=template&id=7477af98&scoped=true&"
import script from "./BlockRequisitesItem.vue?vue&type=script&lang=ts&"
export * from "./BlockRequisitesItem.vue?vue&type=script&lang=ts&"
import style0 from "./BlockRequisitesItem.vue?vue&type=style&index=0&id=7477af98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7477af98",
  null
  
)

export default component.exports